import React, { useId } from 'react';
import { Card, CardContent, Typography, useTheme } from '@mui/material';

// One flat bordered card with a small uppercase label, rendered as the card's h2.
const SectionCard: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => {
  const { palette } = useTheme();
  const headingId = useId();
  return (
    <Card component="section" aria-labelledby={headingId} elevation={0} sx={{ border: `1px solid ${palette.tokens.hairline}`, minWidth: 0 }}>
      <CardContent sx={{ p: 3, '&:last-child': { pb: 3 } }}>
        <Typography
          id={headingId}
          component="h2"
          sx={{ fontSize: '12px', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: palette.tokens.muted, mb: 2 }}
        >
          {title}
        </Typography>
        {children}
      </CardContent>
    </Card>
  );
};

export default SectionCard;
